import {
    Header,
    HeaderContainer,
    HeaderImg,
    HeaderContainerInfosUl,
    HeaderContainerInfosLi,
    HeaderEspecs,
    HeaderEspecsContainer,
    HeaderEspecsUl,
    HeaderEspecsLiReact,
    HeaderEspecsLi,
    HeaderEspecsEstatiscas,
    HeaderEspecsEstatiscasH5,
} from './styles';
import FadeIn from 'react-fade-in';
import logo from './Foto.jpg';
import css from './imgsEspecs/css.png';
import js from './imgsEspecs/js.png';
import react from './imgsEspecs/react.png';
import typescript from './imgsEspecs/typescript.png';
import styled from 'styled-components';
/////////////////////////////////////////////
import csharpe from './frameorks/csharpe.png';
import cmasmas from './frameorks/cmasmas.png';
import java from './frameorks/java.png';
import c from './frameorks/c.png';
import php from './frameorks/php.png';
import python from './frameorks/python.png';

const HeaderContainerDescripitions = styled.div`
    display: ${props => props.display};
    margin-top: -230px;
    margin-left: 30pc;
    padding-left: 700px;
    width: 300px;
    height: 230px;
    background-color: #000000;
    border: 1px solid #1b1b1b;
    box-shadow: 0px 8px 30px #000000;
    border-radius: 15px;
`;

const HeaderContainerDescripitionsSpan = styled.span`
    margin-left: -680px;
    margin-top: 10px;
    justify-content: center;
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: white;
`;
const HeaderContainerDescripitionsUl = styled.ul`
    list-style-type: none;
    display: flex;
    gap: 40px;
    margin-left: -580px;
    margin-top: 15px;
`;

const HeaderContainerDescripitionsLi = styled.li`
    img {
        display: flex;
        width: 40px;
    }
`;

const Resumo = ({displayResume}) => {
    return (
        <>
            <FadeIn duration={500}>
                <Header display={displayResume}>
                    <HeaderContainer>
                        <HeaderImg>
                            <img src={logo} />
                        </HeaderImg>
                        <HeaderContainerInfosUl>
                            <HeaderContainerInfosLi>
                                Nome : Arthur Gosi Dos Santos
                            </HeaderContainerInfosLi>
                        </HeaderContainerInfosUl>
                        <HeaderContainerInfosUl>
                            <HeaderContainerInfosLi>
                                Idade : 17 Anos
                            </HeaderContainerInfosLi>
                        </HeaderContainerInfosUl>
                        <HeaderContainerInfosUl>
                            <HeaderContainerInfosLi>
                                Nacionalidade : Brasileiro
                            </HeaderContainerInfosLi>
                        </HeaderContainerInfosUl>
                        <HeaderContainerInfosUl>
                            <HeaderContainerInfosLi>
                                Cidade : Rio de Janeiro
                            </HeaderContainerInfosLi>
                        </HeaderContainerInfosUl>
                        <HeaderContainerInfosUl>
                            <HeaderContainerInfosLi>
                                Profissão : Programador Junior
                            </HeaderContainerInfosLi>
                        </HeaderContainerInfosUl>
                    </HeaderContainer>
                </Header>
                <HeaderEspecs display={displayResume}>
                    <HeaderEspecsContainer>
                        <HeaderEspecsUl>
                            <HeaderEspecsLiReact>
                                <img src={react} />
                                <HeaderEspecsEstatiscas
                                    backgroundColor={'#00bbd4'}
                                    color={'#00bbd4'}
                                >
                                    <HeaderEspecsEstatiscasH5 color={'#00bbd4'}>
                                        65%
                                    </HeaderEspecsEstatiscasH5>
                                </HeaderEspecsEstatiscas>
                            </HeaderEspecsLiReact>
                            <HeaderEspecsLi>
                                <img src={js} />
                                <HeaderEspecsEstatiscas
                                    backgroundColor={'#ffdf00'}
                                    color={'#ffdf00'}
                                >
                                    <HeaderEspecsEstatiscasH5 color={'#ffdf00'}>
                                        70%
                                    </HeaderEspecsEstatiscasH5>
                                </HeaderEspecsEstatiscas>
                            </HeaderEspecsLi>
                            <HeaderEspecsLi>
                                <img src={css} />
                                <HeaderEspecsEstatiscas
                                    backgroundColor={'#2196f3'}
                                    color={'#2196f3'}
                                >
                                    <HeaderEspecsEstatiscasH5 color={'#2196f3'}>
                                        55%
                                    </HeaderEspecsEstatiscasH5>
                                </HeaderEspecsEstatiscas>
                            </HeaderEspecsLi>
                            <HeaderEspecsLi>
                                <img src={typescript} />
                                <HeaderEspecsEstatiscas
                                    backgroundColor={'#3178c6'}
                                    color={'#3178c6'}
                                >
                                    <HeaderEspecsEstatiscasH5 color={'#3178c6'}>
                                        30%
                                    </HeaderEspecsEstatiscasH5>
                                </HeaderEspecsEstatiscas>
                            </HeaderEspecsLi>
                        </HeaderEspecsUl>
                    </HeaderEspecsContainer>
                </HeaderEspecs>
                <HeaderContainerDescripitions display={displayResume}>
                    <HeaderContainerDescripitionsSpan>
                        Ola,meu chamo Arthur,tenho 17 anos,tenho experiencia em
                        linguagens como : Lua, Javascript , Css e Typescript ;
                        Pois tenho como principal foco ser um futuro
                        desenvolvedor full stack , e trabalhar na area do
                        React-js tenho conhecimentos com as Frameworks do Redux , Router , Styled Components.Prentendo ter mas conhecimento em linguagens no
                        qual são mais profundas como : Python , Java , C# , PHP
                        , C e C++.
                    </HeaderContainerDescripitionsSpan>
                    <HeaderContainerDescripitionsUl>
                        <HeaderContainerDescripitionsLi><img src={csharpe}/></HeaderContainerDescripitionsLi>
                        <HeaderContainerDescripitionsLi><img src={cmasmas}/></HeaderContainerDescripitionsLi>
                        <HeaderContainerDescripitionsLi><img src={java}/></HeaderContainerDescripitionsLi>
                        <HeaderContainerDescripitionsLi><img src={c}/></HeaderContainerDescripitionsLi>
                        <HeaderContainerDescripitionsLi><img src={php}/></HeaderContainerDescripitionsLi>
                        <HeaderContainerDescripitionsLi><img src={python}/></HeaderContainerDescripitionsLi>
                    </HeaderContainerDescripitionsUl>
                </HeaderContainerDescripitions>
            </FadeIn>
        </>
    );
};

export default Resumo;
